import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="base-rule-modal"
export default class extends Controller {
  connect() {
    console.log("[base-rule-modal] connected")
  }

  handleSubmit(event) {
    console.log("[base-rule-modal] submit-end", event.detail)

    if (!event.detail.success) return

    const modal = window.bootstrap?.Modal.getOrCreateInstance(this.element)
    modal?.hide()
  }
}
